import { faSquareRootVariable } from '@fortawesome/free-solid-svg-icons';
import { useAppDispatch, useAppSelector } from '../../../../../app/config/store';
import React, { useEffect, useState } from 'react';
import { Link, Route, useLocation, useNavigate, useParams } from 'react-router-dom';
import '../../app.scss';
import { Nav, NavItem, NavLink } from 'reactstrap';
import ErrorBoundaryRoutes from '../../../../../app/shared/error/error-boundary-routes';
import PrivateRoute from '../../../../../app/shared/auth/private-route';
import { AUTHORITIES } from '../../../app/config/constants';
import CaseReview from '../case-review/case-review';

function Dashboard() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [showTab, setShowTab] = useState('CaseReview');
  const location = useLocation();
  const account = useAppSelector(state => state.authentication.account);

  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, { state: location.state });
      setShowTab(location.state.toString());
    }
  }, []);

  const hasAnyAuthority = (authorities: string[], hasAnyAuthorities: string[]) => {
    if (authorities && authorities.length !== 0) {
      if (hasAnyAuthorities.length === 0) {
        return true;
      }
      return hasAnyAuthorities.some(auth => authorities.includes(auth));
    }
    return false;
  };

  console.log(account, 'account---');
  return (
    <div className="inner-content-wrap">
      <Nav tabs>
        {hasAnyAuthority(account.authorities, [AUTHORITIES.ADMIN, AUTHORITIES.USER]) && (
          <NavItem>
            <NavLink
              tag={Link}
              to="casereview"
              state="CaseReview"
              onClick={() => setShowTab('CaseReview')}
              active={showTab == 'CaseReview'}
            >
              CaseReview
            </NavLink>
          </NavItem>
        )}
      </Nav>
      <ErrorBoundaryRoutes>
        <Route
          path="/casereview"
          element={
            <div className="tabs-page">
              <CaseReview />
            </div>
          }
        />
      </ErrorBoundaryRoutes>
    </div>
  );
}

export default Dashboard;
